module.exports = __webpack_public_path__ + "static/media/slide6.a11894fa.png";